import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { ColumnConfig } from 'material-dynamic-table';
import { Observable } from 'rxjs';
import { ShimanoLanguageService } from 'src/app/service/language/shimano-language.service';

@Component({
  selector: 'app-employee-status-lists',
  templateUrl: './employee-status-lists.component.html',
  styleUrls: ['./employee-status-lists.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class EmployeeStatusListsComponent implements OnInit {
  @Input() column: ColumnConfig;
  @Input() row: any;
  activeLanguage$: Observable<string> = this.languageService.getActive();

  constructor(private languageService: ShimanoLanguageService) {}

  ngOnInit() {}
}
